import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

// 接口原始返回
export interface OrderSeatListItemResponse {
  id: string;
  agent_id: number;
  seat_type: string;
  name: string;
  price: number;
  gift_points: number;
  duration_days: number;
  status: number;
  total_count: number;
  used_count: number;
  remaining_count: number;
  sold_percent: number;
}

// 接口原始返回
export interface OrderSeatListResponse {
  total: number;
  list: OrderSeatListItemResponse[];
  page: number;
  page_size: number;
}

interface OrderSeatListRequest {
  agentId: string | number;
  page: number;
  pageSize: number;
  /** 1=上架，0=下架 */
  status?: 0 | 1;
  /** 是否仅查询有销量的席位 */
  hasSales?: boolean;
}

export class OrderSeatData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;
}

export class OrderSeatListData {
  @IsArray("List must be an array")
  @ValidateNested(OrderSeatData)
  list: OrderSeatData[];
}

const transformAndValidateOrderSeatList = (
  response: OrderSeatListResponse
): OrderSeatListData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, OrderSeatListData);
  } catch (error) {
    console.error("Order seat list validation failed:", (error as Error).message);
    throw error;
  }
};

// 智能体席位商品列表（agent-v2/order-seat-list）
export const orderSeatList = async ({
  agentId,
  page,
  pageSize,
  status,
  hasSales,
}: OrderSeatListRequest): Promise<OrderSeatListData> => {
  const params: Record<string, string | number | boolean> = {
    agent_id: agentId,
    page,
    page_size: pageSize,
  };
  if (status !== undefined && status !== null) {
    params.status = status;
  }
  if (hasSales !== undefined && hasSales !== null) {
    params.has_sales = hasSales;
  }
  const response = await api.get<OrderSeatListResponse>("/agent-v2/order-seat-list", params);
  return transformAndValidateOrderSeatList(response.data);
};
